export const strings = {
    prefixAgo: null,
    prefixFromNow: null,
    suffixAgo: 'sitten',
    suffixFromNow: 'tulevaisuudessa',
    seconds: 'alle minuutti',
    minute: 'minuutti',
    minutes: '%d minuuttia',
    hour: 'tunti',
    hours: '%d tuntia',
    day: 'päivä',
    days: '%d päivää',
    month: 'kuukausi',
    months: '%d kuukautta',
    year: 'vuosi',
    years: '%d vuotta',
};
